import React from 'react';
import styled from 'styled-components';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

function FlightCarriersComponent({ flightCarriers }) {
  return (
    <Root>
      {flightCarriers.map((icon, index) => (
        <img key={`icon-${index}`} src={icon} alt='' />
      ))}
    </Root>
  );
}

export default FlightCarriersComponent;

const Root = styled.div`
  ${flexbox({
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  })}

  position: relative;
  z-index: 1;

  ${mediaQueries.fromAndAbove.tablet`
    width: ${(props) => props.theme.containerWidths.tablet + 'px'};
  `}
  ${mediaQueries.fromAndAbove.desktop`
    width: ${(props) => props.theme.containerWidths.desktop + 'px'};
  `}

  > * {
    max-height: 28px;
    min-width: ${100 / 6}%;
    margin: 24px 16px;
    padding: 0 8px;
  }
`;
